import React, { useRef, useState } from 'react'
import styled from 'styled-components'

const NotesTextarea = styled.textarea<{ $isFocused: boolean }>`
  flex: 1;
  min-height: 60px;
  padding: 0.5rem;
  font-size: 0.75rem;
  font-family: inherit;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.9);
  background: ${(props) =>
    props.$isFocused ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.3)'};
  border: 1px solid
    ${(props) =>
      props.$isFocused
        ? 'rgba(255, 255, 255, 0.3)'
        : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 0.25rem;
  outline: none;
  resize: none;
  transition: all 0.15s ease;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }

  &:hover {
    border-color: rgba(255, 255, 255, 0.2);
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;

    &:hover {
      background: rgba(255, 255, 255, 0.5);
    }
  }
`

interface NotesInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
}

export const NotesInput: React.FC<NotesInputProps> = ({
  value,
  onChange,
  placeholder = 'Add notes...',
  disabled = false,
}) => {
  const [isFocused, setIsFocused] = useState(false)
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const handleKeyDown = (e: React.KeyboardEvent) => {
    e.stopPropagation()
  }

  return (
    <NotesTextarea
      ref={textareaRef}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onKeyDown={handleKeyDown}
      onKeyUp={(e) => e.stopPropagation()}
      placeholder={placeholder}
      $isFocused={isFocused}
      disabled={disabled}
    />
  )
}
